// Product-page "free delivery upgrade" countdown.
// Mirrors assets/countdown-timer.js on Fast Printed Packaging and the 5pm
// working-day cut-off used by sections/exit-intent-upgrade.liquid and
// sections/cart-upgrade-countdown.liquid, so every countdown on the site agrees.
//
// RE-ENABLED 21 September 2026 when the promotion was restarted. Between 14 and
// 21 Sep this counted to the 12:00 midday despatch cut-off instead.
//
// Fixes the previous behaviour where the banner rendered once and then froze on
// its placeholder zeros. The deadline is recalculated on every tick, so once a
// cut-off passes the countdown rolls straight on to the next one instead of
// stopping. Weekends are skipped, so after 5pm on a Friday it counts down to
// 5pm on Monday.
(function () {
  var CUTOFF_HOUR = 17;
  var MS_IN_SEC = 1000;
  var MS_IN_MIN = 60 * MS_IN_SEC;
  var MS_IN_HRS = 60 * MS_IN_MIN;
  var MS_IN_DAY = 24 * MS_IN_HRS;

  function isWorkingDay(date) {
    var day = date.getDay();
    return day >= 1 && day <= 5;
  }

  function getNextCutoff() {
    var now = new Date();
    var dueDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), CUTOFF_HOUR, 0, 0, 0);
    while (dueDate.getTime() <= now.getTime() || !isWorkingDay(dueDate)) {
      dueDate.setDate(dueDate.getDate() + 1);
      dueDate.setHours(CUTOFF_HOUR, 0, 0, 0);
    }
    return dueDate;
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function render() {
    var wrappers = document.querySelectorAll('#delivery_timer_wrapper');
    if (!wrappers.length) return false;

    var remaining = getNextCutoff().getTime() - Date.now();
    if (remaining < 0) remaining = 0;

    var days = Math.floor(remaining / MS_IN_DAY);
    var hours = Math.floor((remaining % MS_IN_DAY) / MS_IN_HRS);
    var minutes = Math.floor((remaining % MS_IN_HRS) / MS_IN_MIN);
    var seconds = Math.floor((remaining % MS_IN_MIN) / MS_IN_SEC);

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var daysEl = wrapper.querySelector('.days');
      var timeEl = wrapper.querySelector('.time');
      var secondsEl = wrapper.querySelector('.seconds');

      if (daysEl) {
        if (days > 0) {
          daysEl.textContent = days + ' Day(s),';
          daysEl.style.display = '';
        } else {
          daysEl.textContent = '';
          daysEl.style.display = 'none';
        }
      }

      if (timeEl) {
        timeEl.textContent = pad(hours) + ' hours, ' + pad(minutes) + ' minutes';
      }

      if (secondsEl) {
        secondsEl.textContent = ', ' + seconds + ' seconds';
      }
    }

    return true;
  }

  function start() {
    if (!render()) return;
    if (window.fppDeliveryUpgradeTimer) clearInterval(window.fppDeliveryUpgradeTimer);
    window.fppDeliveryUpgradeTimer = setInterval(render, MS_IN_SEC);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('pageshow', start);
})();
